<template>
  <draggable-window @show="handleWindowClick" class="program-preview" ref="draggableWindowRef" :visible="visible" :height="divHeight" :width="divWidth" :z-index="zIndex">
    <template #title>
      <div class="program-btn">
        <a-button @click="minimize"><img :src="require('@/assets/home/program-min.png')" style="margin-top: -1px" /></a-button>
        <a-button class="btn" @click="handleCancel"><img :src="require('@/assets/home/program-close.png')" /></a-button>
      </div>
    </template>
    <div class="iframe-wrapper">
	    <zjy-loading v-if="loading" />
	    <iframe v-show="!loading" v-if="urlWithToken" :src="urlWithToken" sandbox="allow-scripts allow-same-origin" @load="onIframeLoad"></iframe>
    </div>
  </draggable-window>
</template>

<script>
import DraggableWindow from '@/components/zjy/DragModal.vue'
import '@/utils/programDrag'
import {getSsoTicket} from '@/api/auth'
import ZjyLoading from "@/components/zjy/ZjyLoading.vue";
export default {
  components: {ZjyLoading, DraggableWindow },
  props: {
    url: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      require: true
    },
	  value: {
		  type: Boolean,
		  require: true
	  },
	  zIndex: {
			type: Number,
			default: 1
	  }
  },
	watch: {
		value(newVal){
			this.visible = newVal;
		}
	},
  computed: {
    divHeight() {
      return this.windowHeight * 0.855;
    },
    divWidth() {
      return (this.divHeight / 130) * 69;
    },
  },
  data() {
    return {
	    loading: false,
	    indicator: <a-icon type="loading" style="font-size: 24px" spin />,
	    visible: true,
      record: {},
      urlWithToken: '',
      windowHeight: window.innerHeight,
    }
  },
  mounted() {
    this.init()
    window.addEventListener('resize', this.updateWindowHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowHeight);
  },
  methods: {
	  onIframeLoad() {
		  this.loading = false
	  },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight;
    },
    async init() {
      this.visible = true;
      await this.buildUrl();
    },
    minimize() {
      this.visible = false
	    this.$emit('input', this.visible)
    },
    handleCancel() {
	    this.$store.dispatch('RemoveProgramIframe', this.id);
    },
    async buildUrl() {
			this.loading = true
      const param = {
        appId: this.id,
        redirectUrl: this.url
      }
      const response = await getSsoTicket(param)
      this.urlWithToken = response.data + '&device=mobile'
    },
	  handleWindowClick() {
		  this.$emit('show');
	  }
  }
}
</script>

<style scoped lang="less">
.program-preview {
  &.draggable-window {
    :deep(.draggable-header) {
      width: 100%;
      height: 10px;
      padding: 0;
      background: transparent;
      cursor: move;
      position: relative;
      z-index: 1;
      .program-btn {
        top: 8px;
        right: 4px;
        padding: 0;
        position: absolute;
        text-align: right;
        &:before {
          content: '';
          position: absolute;
          height: 18px;
          width: 1px;
          background: rgb(230,230,230);
          top: 7px;
          left: 39px;
        }
        .ant-btn {
          background: rgba(255,255,255,0.5);
          border-radius: 16px;
          border-color: #FAFAFA;
          box-shadow: none;
          font-size: 16px;
          color: #191919;
          padding: 0 11px;
          img {
            height: 16px;
          }
          &:hover {
            background: rgba(230,230,230, 0.5);
            border-color: rgba(230,230,230, 0.5);
          }
          &:first-child {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-right: 0;
          }
          &:last-child {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-left-color: transparent;
          }
        }
      }
    }
    :deep(.draggable-content) {
      height: 100%;
      margin-top: -10px;
    }
  }
  .iframe-wrapper {
    height: 100%;
	  display: flex;
	  flex: 1;
	  justify-content: center;
	  align-items: center;
    iframe {
      width: 100%;
      height: 100%;
      border: 0;
      display: block;
    }
  }
}
</style>
